import Separator from "@components/CustomTypography/Separator/Separator"
import HeadMeta from "@components/Theme/HeadMeta/HeadMeta"
import {getPosts} from "@config/modules"
import {MediaGalleryModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import Gallery from "@jsons/gallery.json"
import GalleryContainerSection from "@pages/Media/GalleryPage/GalleryContainerSection/GalleryContainerSection"
import React from "react"

type Props = {}

const gallery = (props: Props) => {
	const GalleryData = getPosts("MediaGalleryModule", {data: Gallery})

	return (
		<Separator size={128}>
			<HeadMeta
				meta={{
					author: "Dream Broker",
					description: "Gallery",
					keywords: "iamges",
					ogDescription: "Gallery",
					ogImage: "/DB.jpg",
					ogTitle: "Dream Broker - Gallery",
					ogType: "WebPage",
					title: "Gallery | Dream Broker",
				}}
			/>

			{GalleryData.map(
				(element: MediaGalleryModuleType, index: number) => {
					return (
						<React.Fragment key={index}>
							{index > 0 && (
								<GalleryContainerSection data={element} />
							)}
							{index < GalleryData.length - 1 && index > 0 && (
								<Separator size={128} />
							)}
						</React.Fragment>
					)
				},
			)}
		</Separator>
	)
}

export default gallery
